module.exports = __webpack_public_path__ + "static/media/BSHARE-BNB.f116e593.png";